export default __webpack_public_path__ + "static/media/1.bffc2adb.jpg";